import usePreviousRoute from '~/composables/usePreviousRoute';

export default defineNuxtRouteMiddleware((to, from) => {
    const { previousRoute } = usePreviousRoute();

    if (to.fullPath !== from.fullPath) {
        previousRoute.value = from;
    }
});
